module.exports = __webpack_public_path__ + "static/media/mastercard.87f7e350_UI.svg";